import * as backend from '../lib/api/src/index'

import store from '@/store'
import { requiresLogin } from '@/utils/error-handler'

export const client = new backend.ApiClient()
client.enableCookies = true

const api = {}

// 分割されたクライアントをすべて統合する
for (const constructorName of Object.keys(backend)) {
  if (!constructorName.endsWith('Api') || typeof backend[constructorName] !== 'function') {
    continue
  }

  // クライアントのすべてのメソッドをapiから呼び出せるようにする
  const constructor = backend[constructorName]
  const delegate = new constructor(client)
  for (const propertyName of Object.getOwnPropertyNames(constructor.prototype)) {
    // コンストラクタ以外のfunctionを残す
    if (propertyName === 'constructor') {
      continue
    }
    const property = delegate[propertyName]
    if (typeof property !== 'function') {
      continue
    }

    api[propertyName] = function (...args) {
      return property.apply(delegate, args)
    }
  }
}

// ApiへのアクセスをプロキシしてApiコールをエラーハンドラーでラップする

const errorHandler = err => {
  if (requiresLogin(err)) {
    store.dispatch('auth/clearLoginInfo')
    return
  }
  throw err
}

const apiWrapper = fn => (...args) => fn.apply(api, args).catch(errorHandler)

const handler = {
  get: function (obj, prop) {
    if (typeof obj[prop] !== 'function') {
      return obj[prop]
    } else {
      return apiWrapper(obj[prop])
    }
  }
}

const proxy = new Proxy(api, handler)

export { proxy as api }
